import React, { useCallback } from 'react';
import InputAdornment from '@mui/material/InputAdornment';
import { Box, Stack, Typography } from '@mui/material';

import { TextField } from '@occc-app/design-system';
import { ClearIcon, IconButton } from '@occc/ui-design-system';
import { parseNumber } from '@occc-app/lib/finalFormUtils';
import { AgeWithinValues } from './types';

type AudienceAgeWithinFormContentProps = {
  values: AgeWithinValues;
  name: string;
  clearFormField: (name: string) => void;
};

export const AgeWithinFormContent: React.FC<AudienceAgeWithinFormContentProps> = React.memo(
  ({ values, name, clearFormField }) => {
    const renderInputAdornment = useCallback(
      (fieldName: string) => {
        const onClear = () => {
          clearFormField(fieldName);
        };
        return (
          <InputAdornment position='end'>
            <IconButton onClick={onClear} size='small'>
              <ClearIcon fontSize='inherit' />
            </IconButton>
          </InputAdornment>
        );
      },
      [clearFormField],
    );

    return (
      <Box mb={2}>
        <Typography paragraph variant='subtitle1'>
          Age
        </Typography>
        <Stack direction='row' spacing={2} alignItems='center'>
          <TextField
            name={`${name}.minimumAge`}
            label='Minimum'
            fieldProps={{ parse: parseNumber }}
            InputProps={{
              endAdornment: !!values?.minimumAge && renderInputAdornment(`${name}.minimumAge`),
            }}
          />
          <Typography variant='subtitle1'>–</Typography>
          <TextField
            name={`${name}.maximumAge`}
            label='Maximum'
            fieldProps={{ parse: parseNumber }}
            InputProps={{
              endAdornment: !!values?.maximumAge && renderInputAdornment(`${name}.maximumAge`),
            }}
          />
        </Stack>
      </Box>
    );
  },
);
